import { useState } from 'owa-react';
import { useSideEffect } from 'owa-react-hooks/lib/useSideEffect';
import fetchDarkModeTenantLogo from '../utils/charms/fetchDarkModeTenantLogo';

export interface DarkModeTenantLogoState {
    isLoading: boolean;
    darkLogoSrc: string | null;
}

export default function useDarkModeTenantLogo(shouldFetch: boolean): DarkModeTenantLogoState {
    const [isLoading, setIsLoading] = useState<boolean>(shouldFetch);
    const [darkLogoSrc, setDarkLogoDataUri] = useState<string | null>(null);

    useSideEffect(
        'useDarkModeTenantLogo',
        () => {
            if (!shouldFetch) {
                setIsLoading(false);
                setDarkLogoDataUri(null);
                return;
            }

            setIsLoading(true);
            let cancelled = false;

            fetchDarkModeTenantLogo().then(logoDataUri => {
                if (!cancelled) {
                    setDarkLogoDataUri(logoDataUri);
                    setIsLoading(false);
                }
            });

            return () => {
                cancelled = true;
            };
        },
        [shouldFetch]
    );

    return { isLoading, darkLogoSrc };
}
